import Layout from 'components/Layout';
import RcPagination from 'rc-pagination';
import React, { useCallback, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  FormGroup,
  Input,
  Table,
} from 'reactstrap';


import Loader from '../components/Loader';
import {
  deleteCafeWorldDetail,
  getCafeWorldList,
} from '../redux/actions/data/uuCafeWorldAction';
import style from '../styles/layout.module.css';
import MessageUtil from '../utils/MessageUtil';
import history from '../utils/createHistory';

const CafeWorld = () => {
  const dispatch = useDispatch();
  const { loading, worldList } = useSelector(state => state.cafeWorldList);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const handlePageChange = useCallback(
    (value, keyword) => {
      dispatch(
        getCafeWorldList({
          keyword,
          page: value,
          page_size: worldList.page_size || 10,
          type: 0,
        }),
      );
      setPage(value);
    },
    [dispatch, setPage, worldList],
  );

  const handleDeleteCafeWorld = useCallback(
    async cafeWorld => {
      try {
        await deleteCafeWorldDetail(cafeWorld);
        MessageUtil.toastSuccess('刪除成功!');
        handlePageChange(1, keyword);
      } catch (e) {
        MessageUtil.alertWanring('刪除失敗!', e);
      }
    },
    [keyword, handlePageChange],
  );

  useEffect(() => {
    handlePageChange(1, keyword);
  }, []);

  return (
    <Layout
      pageTitle="咖啡世界"
      items={[
        { isActive: true, page_name: 'UUCafe' },
        { isActive: true, page_name: '咖啡世界' },
      ]}
    >
      <Card className={style.search_card} style={{ overflow: 'hidden' }}>
        <CardHeader
          className={style.card_header}
          style={{ background: 'white' }}
        >
          搜尋條件
        </CardHeader>
        <CardBody>
          <FormGroup className="d-flex align-items-center">
            <label className="mx-3">關鍵字:</label>
            <Input
              style={{ maxWidth: '200px' }}
              placeholder="輸入關鍵字"
              value={keyword}
              onChange={e => {
                setKeyword(e.target.value);
              }}
            />
          </FormGroup>
        </CardBody>
        <CardFooter className="text-end border-0">
          <Button
            type="button"
            className={style.modal_button_cancel}
            onClick={() => {
              setKeyword('');
            }}
          >
            <span className="btn-wrapper--label">取消</span>
          </Button>
          <Button
            type="button"
            color="primary"
            onClick={() => {
              handlePageChange(1, keyword);
            }}
          >
            <span className="btn-wrapper--label">搜尋</span>
          </Button>
        </CardFooter>
      </Card>
      <Card className={`${style.search_card} ${style['seo-card-layout']}`}>
        {!loading ? (
          <>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <Button
                color="success"
                onClick={() => {
                  history.push('/UUCafe/CafeWorld/add');
                }}
              >
                新增
              </Button>
            </div>
            <p className="small text-end mb-0">共 {worldList.total_count} 筆</p>
            <div
              className={style.table_overflow}
              style={{ minHeight: '200px' }}
            >
              <Table hover bordered striped>
                <thead className={`thead-dark ${style.table_head}`}>
                  <tr>
                    <th nowrap="nowrap">標題</th>
                    <th nowrap="nowrap">上架區間</th>
                    <th nowrap="nowrap">圖片</th>
                    <th style={{ minWidth: '120px' }}>異動日期</th>
                    <th>功能</th>
                  </tr>
                </thead>
                <tbody>
                  {worldList.datas.map((data, index) => (
                    <tr key={index}>
                      <td>{data.title}</td>
                      <td>
                        <div className="text-nowrap">
                          起: {data.startDateTime}
                        </div>
                        <div className="text-nowrap">
                          迄: {data.endDateTime}
                        </div>
                      </td>
                      <td className="text-center" width="150">
                        <img
                          className={style.w200}
                          src={data.imgUrl}
                          alt={data.imgFile}
                        />
                      </td>
                      <td>
                        <div className="text-nowrap">{data.updateDateTime}</div>
                        <div>{data.updater}</div>
                      </td>
                      <td nowrap="nowrap" className="text-center">
                        <Button
                          className="m-1"
                          size="sm"
                          outline
                          color="primary"
                          onClick={() => {
                            history.push(`/UUCafe/CafeWorld/${data.id}`);
                          }}
                        >
                          編輯
                        </Button>
                        <Button
                          className="m-1"
                          size="sm"
                          outline
                          color="danger"
                          onClick={() => {
                            MessageUtil.submitConfirm({
                              doneFun: () => {
                                handleDeleteCafeWorld(data);
                              },
                              title: '確認是否刪除',
                            });
                          }}
                        >
                          刪除
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <RcPagination
                current={page}
                pageSize={worldList.page_size || 10}
                total={worldList.total_count || 1}
                onChange={value => {
                  handlePageChange(value, keyword);
                }}
              />
            </div>
          </>
        ) : (
          <Loader />
        )}
      </Card>
    </Layout>
  );
};

export default CafeWorld;
